import React from 'react';
import { DESKTOP, getResolution } from './responsiveIdentifier';

export default function responsive(ChartComponent) {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        resolution: DESKTOP,
      };
    }

    componentDidMount() {
      window.addEventListener('resize', () => this.updateResolution());
      this.updateResolution();
    }

    onEchartsLoaded(echarts) {
      this.chartRef = echarts;
    }

    updateResolution() {
      if (!this.chartRef) {
        return;
      }

      const { echarts } = this.chartRef;

      // const height = echarts._dom.clientHeight;
      const width = echarts._dom.clientWidth;

      const resolution = getResolution(width);

      this.setState({
        resolution,
      });
    }

    render() {
      const { resolution } = this.state;
      return (
        <ChartComponent
          {...this.props}
          ref={(echarts) => this.onEchartsLoaded(echarts)}
          resolution={resolution}
        />
      );
    }
  };
}
